module.exports = {
      id: "photostory-usage",
      viewBox: "0 0 50.625 54",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#photostory",
      toString: function () {
        return this.url;
      }
    }